/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/ProtocolValue
 * @desc Renders an ProtocolValue node
 */

import { ICONS } from 'labstep-web/constants/icons';
import ProtocolChildRouter from 'labstep-web/containers/Router/ProtocolChild';
import type { Entity } from 'labstep-web/models/entity.model';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import { InlineView as ViewInline } from 'labstep-web/prosemirror/components/Inline/View';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type { ProtocolValueNodeProps } from './types';

export class ProtocolValueNode extends React.Component<ProtocolValueNodeProps> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { id, timestamp } = this.props;
    const { entityName } = ProtocolValue;
    return (
      <ProtocolChildRouter route="value_show" id={id}>
        {({ navigate }) => (
          <Read entityName={entityName} id={id} timestamp={timestamp}>
            {({ entity: protocolValue }: { entity: Entity }) => (
              <ViewInline
                entity={protocolValue}
                onClick={!timestamp ? (navigate as any) : null}
                icon={ICONS.protocol.value}
              >
                {(protocolValue as ProtocolValue).label}
              </ViewInline>
            )}
          </Read>
        )}
      </ProtocolChildRouter>
    );
  }
}

export const ProtocolValueNodeView = ({ timestamp }: any) => {
  const context = useReactNodeView();
  const { guid } = (context.node as any).attrs;
  return <ProtocolValueNode id={guid} timestamp={timestamp} />;
};
